import client from "./internal/httpClient";

const cardApi = {}

cardApi.list = function () {
    return client.post("/door-client/cms/card/list.php")
}

export default cardApi